import { Box, Typography } from '@mui/material';
import ReviewerProfile from '../../../../components/common/ReviewerProfile';
import EditDeleteMenuButton from '../../../../components/button/EditDeleteMenuButton';
import { trackExternalLinkClick } from '../../../../lib/gaEvents';
import { EXTERNAL_LINK_TYPE } from '../../../../constants/gaEnums';
import { useUserStore } from '../../../../stores/userStore';
import { useLocation } from 'react-router-dom';
import { getPageTypeFromPath } from '../../../../lib/gaParams';
import theme from '../../../../theme';

const CriticReviewItem = ({ review, isAdmin, onEdit, onDelete }) => {
  const user = useUserStore((state) => state.user);
  const { pathname } = useLocation();
  const pageType = getPageTypeFromPath(pathname);
  const authorName = [review.sourceName, review.author].filter(Boolean).join(' - ');

  const handleLinkClick = () => {
    trackExternalLinkClick({ linkType: EXTERNAL_LINK_TYPE.CRITIC_REVIEW, pageType }, user);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2,
        py: 1.5,
      }}
    >
      {/* 작성자 영역 */}
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <ReviewerProfile
          imageUrl={review.sourceImage}
          name={authorName}
          rating={review.rating}
          imageHref={review.originalReviewUrl}
          nameHref={review.originalReviewUrl}
          onLinkClick={handleLinkClick}
        />
        {isAdmin && (
          <EditDeleteMenuButton
            variant="small"
            onEdit={() => onEdit(review)}
            onDelete={() => onDelete(review.id)}
          />
        )}
      </Box>

      {/* 리뷰 본문 + 날짜 */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Typography
          component="a"
          href={review.originalReviewUrl}
          target="_blank"
          rel="noopener noreferrer"
          onClick={handleLinkClick}
          fontSize={14}
          color={theme.palette.black[6]}
          sx={{
            lineHeight: 1.5,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            textDecoration: 'none',
            cursor: 'pointer',
          }}
        >
          {review.content}
        </Typography>
        {review.reviewDate && (
          <Typography fontSize={14} color={theme.palette.black[1]}>
            {review.reviewDate}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default CriticReviewItem;
